import React from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import { Button } from "../../components/Button";
import { useNavigate } from "react-router-dom";

import { CommonConsult } from "../../blocks/common-consult";

export const MainTwoThings = () => {
  const { t } = useTranslation();
  const nav = useNavigate();
  const userManageList = [
    [
      {
        title: `${t("page.twoThing.item-one.list-one")}`,
        path: "//docs.authing.cn/v2/guides/authentication/social/",
        type: "outlink",
      },
      { title: `${t("page.twoThing.item-one.list-two")}`, path: "/verify", type: "inlink" },
      { title: `${t("page.twoThing.item-one.list-three")}`, path: "/mfa", type: "inlink" },
    ],
    [
      { title: `${t("page.twoThing.item-one.list-four")}`, path: "/learn/sso", type: "inlink" },
      { title: `${t("page.twoThing.item-one.list-five")}`, path: "/learn/guard", type: "inlink" },
      {
        title: `${t("page.twoThing.item-one.list-six")}`,
        path: "//docs.authing.cn/v2/guides/pipeline/",
        type: "outlink",
      },
    ],
  ];
  const enterpriseList = [
    [
      { title: `${t("page.twoThing.item-two.list-one")}`, path: "/learn/sso", type: "inlink" },
      { title: `${t("page.twoThing.item-two.list-two")}`, path: "/mfa", type: "inlink" },
      { title: `${t("page.twoThing.item-two.list-three")}`, path: "/", type: "other" },
    ],
    [
      {
        title: `${t("page.twoThing.item-two.list-four")}`,
        path: "https://docs.authing.cn/v2/guides/access-control/",
        type: "outlink",
      },
      { title: `${t("page.twoThing.item-two.list-five")}`, path: "/verify", type: "inlink" },
    ],
  ];
  const onLink = (path, type) => {
    if (type === "outlink") {
      window.open(path);
    } else if (type === "inlink") {
      nav(path);
    }
  };
  return (
    <div className="towThing">
      <div className="inner">
        <div key="1" className="top">
          <div className="headline">{t("page.twoThing.title")}</div>
          <div className="subline">{t("page.twoThing.subtitle")}</div>
        </div>

        <div key="2" className="warpBlock">
          <div className="card">
            <div className="icon">
              <img src={"//files.authing.co/authing-website/icon-user-identity.svg"} alt="authing icon" />
            </div>
            <div className="decorate-icon">
              <img src={"//files.authing.co/authing-website/home-decorate.svg"} alt="authing decorate" />
            </div>
            <div className="content">
              <div className="title">{t("page.twoThing.item-one.title")}</div>
              <div className="subTitle">{t("page.twoThing.item-one.subtitle")}</div>
              <div className="itemWarp">
                {userManageList.map((itemArr, index) => {
                  return (
                    <div key={index} className="item">
                      {itemArr.map((item, itemIndex) => {
                        return (
                          <div key={itemIndex} className="item-list">
                            <span
                              className="item-text"
                              onClick={() => {
                                onLink(item.path, item.type);
                              }}
                            >
                              {item.title}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          <div className="card">
            <div className="icon">
              <img src={"//files.authing.co/authing-website/icon-employee-identity.svg"} alt="authing icon identity" />
            </div>
            <div className="decorate-icon">
              <img src={"//files.authing.co/authing-website/home-decorate.svg"} alt="authing icon decorate" />
            </div>
            <div className="content">
              <div className="title">{t("page.twoThing.item-two.title")}</div>
              <div className="subTitle">{t("page.twoThing.item-two.subtitle")}</div>
              <div className="itemWarp">
                {enterpriseList.map((itemArr, index) => {
                  return (
                    <div key={index} className="item">
                      {itemArr.map((item, itemIndex) => {
                        return (
                          <div key={itemIndex} className="item-list">
                            {item.type === "other" ? (
                              <CommonConsult
                                aside={
                                  <span className="item-text" style={{ cursor: "pointer" }}>
                                    {t("page.twoThing.item-two.list-three")}
                                  </span>
                                }
                              />
                            ) : (
                              <span
                                className="item-text"
                                onClick={() => {
                                  onLink(item.path, item.type);
                                }}
                              >
                                {item.title}
                              </span>
                            )}
                            {/* <CommonConsult aside={<span>{t("page.button-开发咨询")}</span>} /> */}
                          </div>
                        );
                      })}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <div key="3" className="buttonWarp">
          <CommonConsult aside={<Button>{t("common.button.consult")}</Button>} />
          {/* <Button title={t("page.button-开发咨询")} /> */}
        </div>
      </div>
    </div>
  );
};
